var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useReducer } from "react";
import Media from "react-media";
import useOnnitContext from "../hooks/useOnnitContext";
import Box from "../box/Box";
import Text from "../text/Text";
import TextField from "../form/textfield/TextField";
import CheckBox from "../form/toggle/CheckBox";
import Button from "../button/Button";
import { useForm, Controller } from "react-hook-form";
import { string, object, boolean, ref } from "yup";
import MessageBox, { MessageLevelEnum } from "../notification/MessageBox";
import ReCAPTCHA from "react-google-recaptcha";
import { yupResolver } from "@hookform/resolvers/yup";
import { Sup } from "../text";
function makeFormSchema(includePasswordFields, includeEmailConfirmation) {
    var schema = {
        firstname: string().label("First name").required().min(3),
        lastname: string().label("Last name").required().min(3),
        email_address: string().label("Email").required().email("Invalid email"),
        newsletter: boolean(),
    };
    if (includeEmailConfirmation) {
        schema.email_address2 = string()
            .label("Email Confirmation")
            .required()
            .email("Invalid email")
            .oneOf([ref("email_address")], "Email addresses must match");
    }
    if (includePasswordFields) {
        schema.password = string().label("Password").required().min(6);
        schema.confirmation = string()
            .label("Password")
            .required()
            .min(6)
            .oneOf([ref("password")], "Passwords must match");
    }
    return yupResolver(object().shape(schema));
}
function makeRequestPayload(values, recaptchaToken, location, csrfTokenArray) {
    var _a, _b, _c;
    var formData = new FormData();
    formData.set("action", "create_account_process");
    formData.set("firstname", values.firstname);
    formData.set("lastname", values.lastname);
    formData.set("email_address", values.email_address);
    formData.set("email_address2", (_a = values.email_address2) !== null && _a !== void 0 ? _a : values.email_address);
    formData.set("g-recaptcha-response", recaptchaToken);
    formData.set("is_create_account", "1");
    formData.set("newsletter", values.newsletter ? "1" : "0");
    formData.set("lead_source_new", "onnit:favorites");
    formData.set("_CSRF_TOKEN", csrfTokenArray._CSRF_TOKEN);
    formData.set("_CSRF_INDEX", csrfTokenArray._CSRF_INDEX);
    if (values.password && values.confirmation) {
        formData.set("password", values.password);
        formData.set("confirmation", values.confirmation);
    }
    if (values.newsletter) {
        (_c = (_b = window.ONNIT) === null || _b === void 0 ? void 0 : _b.googleTagManager) === null || _c === void 0 ? void 0 : _c.newsletterRegistered(location);
    }
    return formData;
}
var initialState = {
    status: "initial",
    error: undefined,
};
function reducer(state, action) {
    switch (action.type) {
        case "reset":
            return __assign({}, initialState);
        case "submit":
            return {
                status: "submitting",
                error: undefined,
            };
        case "success":
            return {
                status: "success",
                error: undefined,
            };
        case "error":
            return {
                status: "error",
                error: action.error,
            };
        default:
            return __assign({}, initialState);
    }
}
function NewCustomerRegistrationForm(_a) {
    var _this = this;
    var _b;
    var _c = _a.includePasswordFields, includePasswordFields = _c === void 0 ? true : _c, _d = _a.includeEmailConfirmation, includeEmailConfirmation = _d === void 0 ? true : _d, _e = _a.successMessage, successMessage = _e === void 0 ? "Your account was created successfully." : _e, location = _a.location, onSuccess = _a.onSuccess, onClose = _a.onClose, boxProps = __rest(_a, ["includePasswordFields", "includeEmailConfirmation", "successMessage", "location", "onSuccess", "onClose"]);
    var onnitContext = useOnnitContext();
    var _f = useReducer(reducer, initialState), state = _f[0], dispatch = _f[1];
    var _g = useForm({
        resolver: makeFormSchema(includePasswordFields, includeEmailConfirmation)
    }), handleSubmit = _g.handleSubmit, errors = _g.errors, control = _g.control;
    var reRef = useRef();
    var getCsrfTokenArray = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, fetch("/cart/create_account.php?action=getBootstrap", {
                    method: "GET",
                    headers: new Headers({
                        "X-Requested-With": "XMLHttpRequest",
                    }),
                })
                    .then(function (response) {
                    if (!response.ok) {
                        return response.json().then(function (text) {
                            throw new Error(text.message.toString());
                        });
                    }
                    return response.json();
                })
                    .then(function (data) {
                    return data;
                })];
        });
    }); };
    var onFormSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var token, csrfTokenArray, error_1, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: "submit" });
                    if (!reRef.current) {
                        return [2];
                    }
                    token = reRef.current.getValue();
                    reRef.current.reset();
                    if (!token) {
                        console.error("Recaptcha token absent");
                        dispatch({ type: "reset" });
                        return [2];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, getCsrfTokenArray()];
                case 2:
                    csrfTokenArray = _a.sent();
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    dispatch({ type: "reset" });
                    return [2];
                case 4:
                    payload = makeRequestPayload(values, token, location, csrfTokenArray);
                    fetch("/cart/create_account.php", {
                        method: "POST",
                        headers: new Headers({
                            "X-Requested-With": "XMLHttpRequest",
                        }),
                        body: payload,
                    })
                        .then(function (response) {
                        var contentType = response.headers.get("content-type");
                        var parseMethod = contentType === "application/json" ? "json" : "text";
                        return response[parseMethod]().then(function (data) {
                            if (response.ok) {
                                return Promise.resolve(data);
                            }
                            else {
                                return Promise.reject(data);
                            }
                        });
                    })
                        .then(function () {
                        dispatch({ type: "success" });
                        onSuccess && onSuccess();
                    })
                        .catch(function (errors) {
                        dispatch({ type: "error", error: Array.isArray(errors) ? errors[0] : errors });
                    });
                    return [2];
            }
        });
    }); };
    if (!onnitContext) {
        return null;
    }
    return (React.createElement(Box, __assign({}, boxProps), state.status === "success" ? (React.createElement(React.Fragment, null,
        React.createElement(MessageBox, { level: MessageLevelEnum.SUCCESS, message: successMessage }),
        React.createElement(Button, { width: ["100%", "auto"], mb: [2, 0], size: "medium", onClick: onClose }, "Close"))) : (React.createElement(React.Fragment, null,
        state.status === "error" && (React.createElement(MessageBox, { level: MessageLevelEnum.ERROR, message: state.error })),
        React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
            React.createElement(Controller, { as: React.createElement(TextField, { name: "firstname", type: "text", label: "First Name", error: errors.firstname && errors.firstname.message }), name: "firstname", control: control, defaultValue: "" }),
            React.createElement(Controller, { as: React.createElement(TextField, { name: "lastname", type: "text", label: "Last Name", error: errors.lastname && errors.lastname.message }), name: "lastname", control: control, defaultValue: "" }),
            React.createElement(Controller, { as: React.createElement(TextField, { name: "email_address", type: "email", label: "Email", error: errors.email_address && errors.email_address.message }), name: "email_address", control: control, defaultValue: "" }),
            includeEmailConfirmation && (React.createElement(Controller, { as: React.createElement(TextField, { name: "email_address2", type: "email", label: "Email Confirmation", error: errors.email_address2 && errors.email_address2.message }), name: "email_address2", control: control, defaultValue: "" })),
            includePasswordFields && (React.createElement(React.Fragment, null,
                React.createElement(Controller, { as: React.createElement(TextField, { name: "password", type: "password", label: "Password", error: errors.password && errors.password.message }), name: "password", control: control, defaultValue: "" }),
                React.createElement(Controller, { as: React.createElement(TextField, { name: "confirmation", type: "password", label: "Confirmation", error: errors.confirmation && errors.confirmation.message }), name: "confirmation", control: control, defaultValue: "" }))),
            React.createElement(Controller, { as: React.createElement(CheckBox, { name: "newsletter", error: (_b = errors.newsletter) === null || _b === void 0 ? void 0 : _b.message, label: (React.createElement(Text, { mt: 1, color: "grays.5", typeStyle: "caption02" },
                        React.createElement(Text, { fontWeight: "bold", display: "inline" }, "Yes"),
                        ", I want to receive offers and updates from US Health & Wellbeing, LLC via email and online marketing. I have read and acknowledge Onnit's",
                        " ",
                        React.createElement("a", { href: "/privacy-policy/", target: "_blank" }, "Privacy Policy"),
                        ". I understand I may unsubscribe from promotional emails at any time.",
                        React.createElement(Sup, { top: -0.1, fontWeight: "heavy" }, "*"))) }), name: "newsletter", control: control, defaultValue: true }),
            React.createElement(Box, { minHeight: "78px" },
                React.createElement(Media, { query: "(min-width: 376px)" }, function (matches) { return (React.createElement(ReCAPTCHA, { sitekey: onnitContext.api_key.recaptcha_public_key, size: matches ? "normal" : "compact", ref: reRef })); })),
            React.createElement(Box, { py: 3 },
                React.createElement(Button, { width: ["100%", "auto"], mb: [2, 0], size: "medium", type: "submit", disabled: state.status === "submitting" }, state.status === "submitting" ? "Sending..." : "Sign up")))))));
}
export default NewCustomerRegistrationForm;
//# sourceMappingURL=NewCustomerRegistrationForm.js.map